// extracted by mini-css-extract-plugin
export default {"player":"Video_player__nldMI","reactPlayer":"Video_reactPlayer__3W8vI"};